import { Routes, Route, useNavigate } from 'react-router-dom';
import {useEffect, useState} from "react";

function Application() {
  const navigate = useNavigate();
  const [isLit, setIsLit] = useState(false);

  useEffect(() => {
    if (isLit) {
      setTimeout(() => {
        navigate('/fire');
      }, 3000)
    }
  }, [navigate, isLit]);

  return (
    <main className="h-screen" onClick={() => {
      navigate('/lighting');
      setIsLit(true);
    }}>
      <Routes>
        <Route
          path="/"
          element={
            <div className="before_lighting">
            </div>
          }
        />
        <Route
          path="/lighting"
          element={
            <div className="lighting">
            </div>
          }
        />
        <Route
          path="/fire"
          element={
            <div className="fire">
              <div className="absolute bottom-0 w-full text-center pb-4">
                <span className="text-white text-4xl">Reaktor Olympics 🏅🏄🏼‍♀️ ⚽️</span>
              </div>
            </div>
          }
        />
      </Routes>
      {/*<Route*/}
      {/*  path="/torch"*/}
      {/*  element={*/}
      {/*    <div className="torch">*/}
      {/*    </div>*/}
      {/*  }*/}
      {/*/>*/}
    </main>
  );
}

export default Application;